















import { Component, Vue } from "vue-property-decorator";
import AppSidebar from "@/components/Sidebar.vue";
import AppNavbar from "@/components/Navbar.vue";
import Auth from "@/store/auth";

@Component({
  components: {
    "app-sidebar": AppSidebar,
    "app-navbar": AppNavbar
  }
})
export default class AppContainer extends Vue {
  isSidebar: boolean = false;

  async onToggleSidebar() {
    this.isSidebar = !this.isSidebar;
  }

  async created() {
    try {
      await Auth.api().auth();
    } catch (error) {
      this.$router.push("/auth");
    }
  }

  onNavigationChanged(isOpen: boolean) {
    this.isSidebar = isOpen;
  }
}
